import * as tslib_1 from "tslib";
import { FormControl } from '@angular/forms';
import { ProductService } from '@core/interfaces';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import { sentry } from 'sentry';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var SEARCH_QUERY = gql(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  query searchProducts($where: ProductsWhereInput $limit: Int $offset: Int) {\n    products(\n      where: $where\n      orderBy: name_asc\n      limit: $limit\n      offset: $offset\n    ){\n      items {\n        id\n        name\n      }\n    }\n  }\n"], ["\n  query searchProducts($where: ProductsWhereInput $limit: Int $offset: Int) {\n    products(\n      where: $where\n      orderBy: name_asc\n      limit: $limit\n      offset: $offset\n    ){\n      items {\n        id\n        name\n      }\n    }\n  }\n"])));
var FcProductInputComponent = /** @class */ (function () {
    function FcProductInputComponent(fuseTranslationLoaderService, apollo) {
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.apollo = apollo;
        this.showSearchIcon = false;
        this.requiredMark = false;
        this.preloadOptions = false;
        this.searchOnFocus = false;
        this.label = null;
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
        this.search = this.search.bind(this);
        this.displayWith = this.displayWith.bind(this);
    }
    FcProductInputComponent.prototype.search = function (searchTerm, limit, offset) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.apollo
                        .query({
                        query: SEARCH_QUERY,
                        variables: {
                            where: {
                                nameContains: searchTerm,
                                archived: false
                            },
                            limit: limit,
                            offset: offset
                        },
                    })
                        .toPromise()
                        .then(function (result) {
                        return result.data['products']['items'];
                    })
                        .catch(function (err) {
                        sentry.captureException(err);
                        return [];
                    })];
            });
        });
    };
    FcProductInputComponent.prototype.displayWith = function (value) {
        return value && value.name;
    };
    return FcProductInputComponent;
}());
export { FcProductInputComponent };
var templateObject_1;
